import { isEmpty } from 'lodash';
import MyUtil from './MyUtil';

const ConvertPartner = {
  handleNew: (data) => {
    let pays = '';
    if (data.pays.length > 0) {
      data.pays.forEach((item) => {
        pays += `${item},`;
      });
    }

    if (pays) pays = pays.substring(0, pays.length - 1);

    let partner = {
      part_id: data.part_id,
      part_name: data.part_name,
      vhc_type_id: data.vhc_type_id,
      part_phon: data.part_phon,
      part_emai: !isEmpty(data.part_emai) ? data.part_emai : null,
      part_logo: data.part_logo,
      city_id: data.city ? data.city.value.city_id : '',
      city_name: data.city ? data.city.value.city_name : '',
      district_name: data.district ? data.district.value.district_name : null,
      district_id: data.district ? data.district.value.district_id : null,
      part_lat: data.part_lat,
      part_lng: data.part_lng,
      part_addr: data.part_addr,
      part_addr_shor: data.part_addr_shor,
      part_ctac_name: data.part_ctac_name,
      part_ctac_mobi: data.part_ctac_mobi,
      part_pay_acc_number: data.part_pay_acc_number,
      part_pay_acc_bank: data.part_pay_acc_bank,
      part_pay_acc_holder: data.part_pay_acc_holder,
      part_web: data.part_web,
      part_stat_time: data.timeStart ? data.timeStart.value : '',
      part_end_time: data.timeEnd ? data.timeEnd.value : '',
      part_last_nigh_supt: data.part_last_nigh_supt ? 1 : 0,
      part_over_time_fee: data.part_over_time_fee
        ? MyUtil.convertMoney(data.part_over_time_fee)
        : '',
      part_lim_km: data.part_lim_km,
      part_over_km_fee: MyUtil.convertMoney(data.part_over_km_fee),
      part_deli_free_km: data.part_deli_free_km,
      part_deli_over_km_fee: data.part_deli_over_km_fee
        ? MyUtil.convertMoney(data.part_deli_over_km_fee)
        : '',
      part_deli_home: data.part_deli_home ? 1 : 0,
      part_polc: data.part_polc,
      part_crta: data.part_crta !== '' ? data.part_crta : new Date(),
      pays,
      procs: data.procs,
      wdays: data.wdays,
      holis: data.holis,
      commission: data.commission,
      status: data.status,
    };

    console.log('partner:', partner);

    partner = MyUtil.clean(partner);
    return partner;
  },

  convertTime: (value) => {
    if (!value) return value;
    const item = value.split(':');
    let strTime = '';
    if (parseInt(item[0]) < 10) {
      strTime += `0${parseInt(item[0])}`;
    } else {
      strTime += parseInt(item[0]);
    }
    strTime += `:${item[1]}`;

    return strTime;
  },
  convertPays: (value, arrPays) => {
    const pays = value.split(',');
    return arrPays.filter((item) => {
      for (let i = 0; i < pays.length; i++) {
        if (MyUtil.slug(pays[i]) === MyUtil.slug(item.label)) return item;
      }
    });
  },
  converParnerEdit: (detail) => {
    let procs = '';
    let wdays = '';
    let holis = '';
    let pays = '';
    let procs_detail = '';

    detail.part_procs.map((item) => {
      const note = item.part_proc_note;
      procs += note
        ? `${item.proc.proc_name}:${note},`
        : `${item.proc.proc_name},`;
    });
    if (procs !== '') procs = procs.substring(0, procs.length - 1);

    detail.part_wdays.map((item) => {
      const note = item.part_wday_exta_fee;
      wdays += `${item.wday.wday_name}:${note},`;
    });
    if (wdays !== '') wdays = wdays.substring(0, wdays.length - 1);

    detail.part_holis.map((item) => {
      const note = item.part_holi_exta_fee;
      holis += `${item.holi.holi_name}:${note},`;
    });
    if (holis !== '') holis = holis.substring(0, holis.length - 1);

    detail.part_pay_meths.map((item) => {
      pays += `${item.pay_meth_name},`;
    });
    if (pays !== '') pays = pays.substring(0, pays.length - 1);

    procs_detail = detail.part_procs;
    return {
      pays,
      holis,
      wdays,
      procs,
      procs_detail,
    };
  },
  handleCheck: (state) => {
    const {
      part_name,
      part_phon,
      city_id,
      part_addr,
      part_ctac_mobi,
      part_ctac_name,
      part_lat,
      part_lng,
      part_polc,
      part_stat_time,
      part_end_time,
    } = state;

    const message = [];
    if (!part_name) message.push('tên đối tác');
    if (!part_phon) message.push('số điện thoại');
    if (!part_addr) message.push('địa chỉ');
    if (!part_ctac_mobi) message.push('số điện thoại liên lạc');
    if (!part_ctac_name) message.push('tên liên lạc');
    if (!(part_stat_time && part_end_time))
      message.push('thời gian bắt đầu, kết thúc');
    if (!(part_lat && part_lng)) message.push('lat, long');
    if (!part_polc) message.push('chính sách');
    if (!city_id) message.push('thành phố');
    return message.length > 0 ? message : false;
  },
};

export default ConvertPartner;
